export default __webpack_public_path__ + "static/play-store-icon-1bcc1c4b53cc8b66c453d2c80a71e33a.svg";